import { render, staticRenderFns } from "./NewVariantAdd.vue?vue&type=template&id=e1ff484e&scoped=true"
import script from "./NewVariantAdd.vue?vue&type=script&lang=js"
export * from "./NewVariantAdd.vue?vue&type=script&lang=js"
import style0 from "./NewVariantAdd.vue?vue&type=style&index=0&id=e1ff484e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff484e",
  null
  
)

export default component.exports